import { ContactLink } from '../../types';

export const contactLinks: ContactLink[] = [
  {
    id: 'email',
    label: 'Email',
    url: 'mailto:marco@marcosantar.com',
    icon: 'email',
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    url: 'https://linkedin.com/in/marco-santarcangelo',
    icon: 'linkedin',
  },
  {
    id: 'github',
    label: 'GitHub',
    url: 'https://github.com/marcosantar93',
    icon: 'github',
  },
  {
    id: 'twitter',
    label: 'X/Twitter',
    url: 'https://x.com/marcosantar93',
    icon: 'twitter',
  },
];
